import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const ModalEditDesktop = ({
  showModalEditDesktop,
  handleCloseModalEditDesktop,
  handleEditDesktop,
  formDataEditDesktop,
  handleInputChangeEditDesktop,
  loadingDesktop,
  desktopModalErrors,
}) => {
  return (
    <div>
      <Modal
        show={showModalEditDesktop}
        onHide={handleCloseModalEditDesktop}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Desktop</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()}>
            {" "}
            {/* Description */}
            <Form.Group
              controlId="description"
              style={{ marginBottom: "10px" }}
            >
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Add some personal notes"
                name="description"
                rows={3}
                value={formDataEditDesktop?.description || ""}
                onChange={handleInputChangeEditDesktop}
                // required={true}
                style={{ resize: "vertical" }}
              />
              {/* {desktopModalErrors.description && (
                <div
                  style={{
                    fontSize: "0.8em",
                    fontStyle: "italic",
                    color: "red",
                  }}
                >
                  {desktopModalErrors.description}
                </div>
              )} */}
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalEditDesktop}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleEditDesktop(formDataEditDesktop)}
            disabled={loadingDesktop}
          >
            {loadingDesktop ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalEditDesktop;
